
/** CSS classes for InCoreFlashBorder */
export const InCoreFlashColor = {
    "Primary": "flash-primary",
    "Secondary": "flash-secondary",
    "Danger": "flash-danger",
    "Success": "flash-success",
    "Info": "flash-info",
    "Warning": "flash-warning",
    "White": "flash-white"
};

/**
 * Highlight the border of an item with a color for a specific time.
 * @param item - The css string to find
 * @param color - The color to show from InCoreFlashColor
 * @param time - How long to highlight the item
 */
export function InCoreFlashBorder(item: string, color: string, time: number) {
    $(item).addClass(color);
    setTimeout(() => { $(item).removeClass(color); }, time);
}